import React, { useCallback, useEffect, useRef, useState } from "react";
import styles from "./StoreTabSelector.module.scss";
import { MenuIcon, SelectArrowDown } from "../../../assets/icons";
import { useNavigate } from "react-router-dom";
import categoryService from "../../../httpService/CategoryService";
import { toast } from "react-toastify";
import { Category } from "../../../model/solar-product/category";
import ViewGuestOrderPopup from "../guest-order-dialog/ViewGuestOrderDialog";

type Props = {};

const StoreTabSelector: React.FC<Props> = (props: Props) => {
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenViewGuestOrder, setIsOpenViewGuestOrder] = useState<Boolean>(false);
	const dropdownRef = useRef<HTMLDivElement | null>(null);
	const navigate = useNavigate();

	const [categories, setCategories] = useState<Category[]>([]);

	const handleClickOutside = (event: MouseEvent) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
			setIsOpen(false);
		}
	};

	useEffect(() => {
		// Attach the click event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Clean up the event listener
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const fetchCategories = useCallback(async () => {
		try {
			const response = await categoryService.get();

			const data = response.data as any;

			setCategories(data.categories);
		} catch (error) {
			toast.error("There was an error fetching Categories");
		}
	}, [categoryService]);

	useEffect(() => {
		fetchCategories();
	}, [fetchCategories]);

	return (
		<div className={styles.container}>
			{isOpenViewGuestOrder && <ViewGuestOrderPopup onCloseDialog={() => setIsOpenViewGuestOrder(!isOpenViewGuestOrder)} />}
			<div className={styles.tabContainer}>
				<div className={styles.categorySelector} onClick={() => setIsOpen(prev => !prev)}>
					<MenuIcon
						style={{
							height: "18px",
							width: "18px",
						}}
					/>{" "}
					All Categories{" "}
					<SelectArrowDown
						style={{
							marginLeft: "0.5rem",
							height: "18px",
							width: "18px",
						}}
					/>
				</div>
				<button onClick={()=>setIsOpenViewGuestOrder(!isOpenViewGuestOrder)} className={styles.categorySelector}>Guest Order Status</button>
				{isOpen && categories.length > 0 && (
					<div className={styles.dropdownMenu} ref={dropdownRef}>
						<div className={styles.dropdownMenuItems}>
							{categories.map(x => (
								<div
									key={x.id}
									className={styles.menuItem}
									onClick={() => {
										setIsOpen(false);
										navigate(`/store/category/${x.name}`);
									}}
								>
									{x.name}
								</div>
							))}
						</div>
					</div>
				)}
				{/* <button className={styles.tab}>Associate Installer</button>
                <button className={styles.tab}>Distributor that installs</button>
                <button className={styles.tab}>Manufacturer that installs</button> */}
			</div>
		</div>
	);
};

export default StoreTabSelector;
